// extracted by mini-css-extract-plugin
export var component = "PostsModuleLinkLayout-module--component--LopUz";
export var filterForm = "PostsModuleLinkLayout-module--filterForm--FCmNg";
export var item = "PostsModuleLinkLayout-module--item--7hMrE";
export var list = "PostsModuleLinkLayout-module--list--u-KIy";